import React from 'react';
import { format } from 'date-fns';
import styled from 'styled-components';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { WEEKDAYS_SHORT, MONTHS } from '../../utils/dayPicker';
const Wrapper = styled.div `
  display: flex;
  &&& {
    .DayPickerInput input {
      padding: 15px;
      width: 100%;
      border: 1px solid #C3C3C3;
      border-radius: 5px;
      background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iSWNvbmVfQWdlbmRhIiBkYXRhLW5hbWU9Ikljb25lIEFnZW5kYSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggaWQ9IkNhbWluaG9fMjIyMCIgZGF0YS1uYW1lPSJDYW1pbmhvIDIyMjAiIGQ9Ik0xNywxMkgxMnY1aDVaTTE2LDFWM0g4VjFINlYzSDVBMS45OTEsMS45OTEsMCwwLDAsMy4wMSw1TDMsMTlhMiwyLDAsMCwwLDIsMkgxOWEyLjAwNiwyLjAwNiwwLDAsMCwyLTJWNWEyLjAwNiwyLjAwNiwwLDAsMC0yLTJIMThWMVptMywxOEg1VjhIMTlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEpIiBmaWxsPSIjNGI0YjRiIi8+CiAgPHBhdGggaWQ9IkNhbWluaG9fMjIyMSIgZGF0YS1uYW1lPSJDYW1pbmhvIDIyMjEiIGQ9Ik0wLDBIMjRWMjRIMFoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+Cg==");
      background-position: 90% 50%;
      background-repeat: no-repeat;
      background-size: 24px;
      font-size: 15px;
      font-family: 'Ubuntu';

    }
    .DayPickerInput-Overlay {
      margin-top: 10px;
      min-height: auto;
      border-radius: 5px;
      border: 1px solid #C3C3C3;
      box-shadow: 0px 20px 20px #00000029;
    }
    .DayPickerInput-OverlayWrapper {
      position: absolute;
      left: 0;
      width: 100%
    }
    .DayPickerInput-wrapper {
      position: absolute;
    }
    .DayPicker, .DayPicker-wrapper, .DayPicker-Month {
      font-size: 15px;
      padding: 10px 10px 10px 10px;
      outline: none; }
  .DayPicker-wrapper, .DayPicker-Month {
    margin: 0;
    padding: 0; }
  .DayPicker-Day {
    border: .5px solid #fff;
    border-radius: 0;
    outline: none;
    padding: 10px 0;
    font-family: 'Ubuntu';
    }
    .DayPicker-Day--today:not(&--disabled) {
      color: #1F35B5; }
    .DayPicker-Day:not(&--disabled):not(&--outside):hover {
      background-color: #a8b2e9 !important; }
    .DayPicker-Day--selected:not(&--outside) {
      background-color: #1F35B5 !important;
      color: #fff !important;
      font-weight: 700; }
    .DayPicker-Day--disabled:not(&--outside) {
      color: #1F35B5;
      position: relative; }
      .DayPicker-Day--disabled:not(&--outside)::before {
        content: '';
        display: block;
        height: 70%;
        width: 1px;
        background-color: #1F35B5;
        position: absolute;
        top: 15%;
        left: 50%;
        transform: rotate(45deg);
        animation: line-through 300ms forwards; }
    .DayPicker-Day--schedule.DayPicker-Day--disabled {
      position: relative; }
      .DayPicker-Day--schedule.DayPicker-Day--disabled::after {
        content: '';
        left: 0;
        right: 0;
        height: 28px;
        width: 28px;
        background: #1F35B5 url("/static/check.svg") no-repeat center center;
        border-radius: 28px;
        left: calc(50% - 14px);
        top: calc(50% - 14px);
        transform: rotate(0deg);
        position: absolute; }
  .DayPicker-Caption {
    margin-bottom: 0.5rem;
    font-family: 'Ubuntu';
    padding: 0; }
    .DayPicker-Caption div {
      align-items: center;
      display: flex;
      font-weight: 700;
      height: 4.2rem;
      justify-content: center;
      text-transform: uppercase; }
  .DayPicker-NavButton {
    background-size: 100%;
    height: 4rem;
    margin-top: 0;
    width: 4rem;
    font-family: 'Ubuntu';
    top: 0; }
    .DayPicker-NavButton:focus {
      outline: none; }
    .DayPicker-NavButton--prev {
      background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iSWNvbl9BcnJvd19MZWZ0IiBkYXRhLW5hbWU9Ikljb24gQXJyb3cgTGVmdCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDIgNDIiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgIH0KCiAgICAgIC5jbHMtMiB7CiAgICAgICAgZmlsbDogIzRjNGM0YzsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHJlY3QgaWQ9IlJlY3RhbmdsZV81MzUiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDUzNSIgY2xhc3M9ImNscy0xIiB3aWR0aD0iNDIiIGhlaWdodD0iNDIiLz4KICA8cGF0aCBpZD0iUGF0aF8yMTgxIiBkYXRhLW5hbWU9IlBhdGggMjE4MSIgY2xhc3M9ImNscy0yIiBkPSJNMTUuNDEsNy40MSwxNCw2LDgsMTJsNiw2LDEuNDEtMS40MUwxMC44MywxMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkgOSkiLz4KPC9zdmc+Cg==");
      left: 0rem;
      margin-right: 0; }
    .DayPicker-NavButton--next {
      background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MiA0MiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjNGI0YjRiOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0iSWNvbl9BcnJvd19SaWdodCIgZGF0YS1uYW1lPSJJY29uIEFycm93IFJpZ2h0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDEyKSI+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzUzNCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNTM0IiBjbGFzcz0iY2xzLTEiIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDEyKSIvPgogICAgPHBhdGggaWQ9IlBhdGhfMjE4MiIgZGF0YS1uYW1lPSJQYXRoIDIxODIiIGNsYXNzPSJjbHMtMiIgZD0iTTcuNDEsMS40MSw2LDAsMCw2bDYsNiwxLjQxLTEuNDFMMi44Myw2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDM4LjQxIDI3KSByb3RhdGUoMTgwKSIvPgogIDwvZz4KPC9zdmc+Cg==");
      right: 0rem; }
  .DayPicker-Weekday {
    color: #1F35B5;
    font-size: 15px;
    font-weight: 700;
    padding: 0;
    font-family: 'Ubuntu';
    padding-bottom: 1.057rem; }

  }
}
`;
export const DatePickerInput = ({ daysUnavailable, handleDayChange, selectedDay }) => {
    return (React.createElement(Wrapper, null,
        React.createElement(DayPickerInput, { dayPickerProps: {
                disabledDays: daysUnavailable,
                selectedDays: selectedDay,
                weekdaysShort: WEEKDAYS_SHORT,
                months: MONTHS,
            }, inputProps: { readOnly: true }, onDayChange: day => handleDayChange(day), placeholder: '--/--/----', value: `${selectedDay ? format(selectedDay, 'dd/MM/yyyy') : ''}` })));
};
//# sourceMappingURL=DatePickerInput.js.map